import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { ISignInRequest, ISignInResponse } from './authentication.types'

export class Authentication extends ServiceBase {
  /**
   * Authentication of a user.
   * @returns object with jwt
   */
  public async signin(body: ISignInRequest): Promise<ISignInResponse> {
    const url = '/auth/login'

    const response = await this.request.post<ISignInResponse, IError>(url, body)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  /**
   * @description Reauth an user for brand view on plataform. In case of not sending a brand name, all brands will be on view
   */
  public async refreshBrandView(brandName?: string): Promise<ISignInResponse> {
    const url = brandName
      ? `/auth/refresh/brand/?brandName=${brandName}`
      : `/auth/refresh/brand`

    const response = await this.request.post<ISignInResponse, IError>(url, {})

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
